export default "__VITE_PUBLIC_ASSET__3b373951__"